import { render, staticRenderFns } from "./message-form.vue?vue&type=template&id=42b57a7a&scoped=true&"
import script from "./message-form.vue?vue&type=script&lang=js&"
export * from "./message-form.vue?vue&type=script&lang=js&"
import style0 from "./message-form.vue?vue&type=style&index=0&id=42b57a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b57a7a",
  null
  
)

export default component.exports